import type { PageStateType } from 'Types/state'
import { atom } from 'recoil'

import getIntl from 'Helpers/intl'

export const pageState = atom<PageStateType>({
  key: 'pageState',
  default: {
    title: '',
    status: 'initial',
    loading: false,
    fetching: false,
    errorMessage: undefined,
  },
})

export const errorUpdater = (prev: PageStateType): PageStateType => ({
  ...prev,
  status: 'error',
  loading: false,
  fetching: false,
  errorMessage: getIntl().formatMessage({
    id: 'Load.Alerts.ErrorGeneric',
  }),
})

export const loaderUpdater =
  (loading: boolean) =>
  (prev: PageStateType): PageStateType => ({
    ...prev,
    loading,
  })
